import { FiltersBar, type SelectOption } from '../../../ui/index.js';
import { AUDIT_EVENT_CODES } from '@magimp/shared';
import { useTranslation } from 'react-i18next';
import { AUDIT_EVENT_LABEL_KEYS } from './AuditTable.js';

export type AuditFilterValue = {
  action: '' | (typeof AUDIT_EVENT_CODES)[number];
  targetType: string;
  targetId: string;
  actorUserId: string;
  dateFrom: string;
  dateTo: string;
};

export interface AuditFiltersBarProps {
  value: AuditFilterValue;
  onChange: (next: AuditFilterValue) => void;
}

export function AuditFiltersBar({ value, onChange }: AuditFiltersBarProps) {
  const { t } = useTranslation('audit');
  const actionOptions: SelectOption[] = [
    { value: '', label: t('filters.allActions') },
    ...AUDIT_EVENT_CODES.map((c) => ({
      value: c,
      label: t(AUDIT_EVENT_LABEL_KEYS[c], { defaultValue: c }),
    })),
  ];
  const targetTypeOptions: SelectOption[] = [
    { value: '', label: t('filters.all') },
    { value: 'user', label: 'user' },
    { value: 'department', label: 'department' },
  ];
  return (
    <FiltersBar
      filters={[
        { type: 'select', key: 'action', label: t('filters.action'), options: actionOptions },
        {
          type: 'select',
          key: 'targetType',
          label: t('filters.targetType'),
          options: targetTypeOptions,
        },
        {
          type: 'search',
          key: 'targetId',
          label: t('filters.targetId'),
          placeholder: t('filters.targetId'),
        },
        {
          type: 'search',
          key: 'actorUserId',
          label: t('filters.actor'),
          placeholder: t('filters.actorPlaceholder'),
        },
        {
          type: 'search',
          key: 'dateFrom',
          label: t('filters.dateFrom'),
          placeholder: t('filters.dateFromPlaceholder'),
        },
        {
          type: 'search',
          key: 'dateTo',
          label: t('filters.dateTo'),
          placeholder: t('filters.dateToPlaceholder'),
        },
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
